import { IFCWithChildren } from '~/common/interfaces/IFCWithChildren';

export const SEOLayout: IFCWithChildren = ({ children }) => <>{children}</>;
